
import { Component, Vue } from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import SonIslemTarihiAyariForm from "@/components/forms/SonIslemTarihiAyariForm.vue";
import { SonIslemTarihiAyariEntity } from "@/entity/SonIslemTarihiAyariEntity";

@Component({
  components: {
    SonIslemTarihiAyariForm,
    FormDialog,
  },
})
export default class SonIslemTarihiAyariList extends Vue {
  items: SonIslemTarihiAyariEntity[] = [];
  search = "";

  headers = [
    { text: "İşlem Tarihi", value: "islemsizlik_uyari_gun_sayisi", align: "start", sortable: false, class: 'my-header-style' },
    { text: "İşlemler", value: "actions", align: 'end', width: '100', sortable: false, class: 'header-actions-style' },
  ];

  mounted() {
    this.loadData();
  }

  loadData() {

    this.$http.get("/api/v1/uyarilar/uyari-gereksinimleri").then((response) => {
      this.items=[response.data];
    }).catch((error) => {
      console.error('Hata son islem tarihi ayari:', error);
      this.items = [];
    });
  }
}
